import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Result() {
  return (
    <section className="result_par result_truth p-100 text_second_text">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center resp_order"
          >
            <div className="result_img">
              <StaticImage
                src="../../../images/case-studies/truth-gpt/The_Result.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={820}
                height={716}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              The <span>Results</span>
            </h2>
            <p>
              The careful analysis of prompt engineering for improved user
              engagement, coupled with Flutter's animation management, resulted
              in enhanced user engagement.
            </p>
            <p>
              The smooth integration of 3D models in Flutter improved overall
              app aesthetics.  Achieving accurate lip-syncing solutions
              contributed to a realistic and immersive user experience.
            </p>
            <p>
              The app's timely completion and successful integration of features
              led to a prompt launch, meeting and exceeding user expectations.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/us/app/truthgpt-ai-chatbot/id6446929134.">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.app.truthgpt&hl=en&gl=US">
                <StaticImage
                  src="../../../images/case-studies/amj/google_play.webp"
                  alt="TekRevol"
                  className="btn_amj "
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Result;
